"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const DeclineAlertMessage = (props) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'alert alert-custom alert-notice alert-light-danger fade show', children: [(0, jsx_runtime_1.jsx)("div", { className: 'alert-icon', children: (0, jsx_runtime_1.jsx)("i", { className: 'flaticon-warning' }) }), (0, jsx_runtime_1.jsxs)("div", { className: 'alert-text', children: [" ", props.declineInvoice.state.data.declineReason] })] }));
};
exports.default = DeclineAlertMessage;
